exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-flex[data-v-68829580] {\n  margin: 30px;\n  justify-content: space-between;\n}", ""]);

// exports
